import React from 'react';
const stats: [string, string][] = [['6', 'Premium Volumes'], ['Complete', 'Professional System'], ['60', 'Page Printable Resource Library'], ['🗺️', 'Therapeutic Maps & Chakra Tools'], ['Ready to Use', 'Session Protocols & Scripts'], ['5', 'Bonus Guides Free']];
export function StatsBar() {
  return <section className="w-full bg-surface px-4 py-10 sm:py-12" data-id="element-215" data-mp="1jb95m9iagz0r">
      <div className="mx-auto grid max-w-6xl grid-cols-2 gap-x-4 gap-y-8 text-center sm:grid-cols-3 lg:grid-cols-6" data-id="element-216" data-mp="1ecz83s93dmbz">
        {stats.map(([value, label]) => <div key={label} data-id="element-217" data-mp="19l7q46404oxg">
            <div className="font-serif text-3xl leading-none text-amber sm:text-4xl" data-id="element-218" data-mp="15kxae1qeqk5e">{value}</div>
            <div className="mt-2 text-[10px] font-bold uppercase tracking-[0.13em] text-navy/70 sm:text-xs" data-id="element-219" data-mp="10lt2rfj4suh6">
              {label}
            </div>
          </div>)}
      </div>
    </section>;
}